var map = {
	"./en.json": 59095,
	"./es.json": 88704,
	"./ja.json": 74397,
	"./ko.json": 59682,
	"./pt.json": 42088,
	"./th.json": 14587,
	"./vi.json": 53273,
	"./zh-Hant.json": 79580,
	"./zh.json": 85626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50742;